import {
  Box,
  styled,
  TableCell,
  TableContainer,
  TableHead,
} from '@mui/material';
import { lang } from 'src/utils';

export const CardGridWrapper = styled(Box)`
  height: 85vh;
  overflow-y: auto;
`;

export const TableBodyContainer = styled(TableContainer)(() => ({
  height: '80vh',
  overflow: 'auto',
  borderRadius: '8px',
  flex: 1,
}));

export const CustomTableHead = styled(TableHead)(({ theme }) => ({
  '& th': {
    position: 'sticky',
    borderBottom: `2px solid ${theme.palette.grey[300]}`,
    fontWeight: 700,
    fontSize: '16px',
    backgroundColor: theme.palette.secondary.lighter,
    padding: '16px',
  },
}));

export const CustomTableCell = styled(TableCell)<{ width: string }>(
  ({ theme, width }) => ({
    position: 'relative',
    fontSize: '14px',
    padding: '15px',
    maxWidth: width,
    borderBottom: `1px solid ${theme.palette.divider}`,

    '& a': {
      color: 'inherit',
      textDecoration: 'none',
    },
  }),
);

export const TableWrapper = styled(Box)({
  borderRadius: '10px',
  border: '1px solid var(--divider, rgba(0, 0, 0, 0.12))',
});

export const CustomTableHeadCell = styled(Box)<{ label: string }>(
  ({ label }) => ({
    display: 'flex',
    border: 'none',
    alignItems: 'center',
    justifyContent: 'start',
    gap: 8,
    paddingLeft: label === lang.name ? '10px' : undefined,
  }),
);
